<angular-editor [(ngModel)]="value" [config]="config"></angular-editor>
